import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-edit-long-prompt-modal',
  templateUrl: './edit-long-prompt-modal.component.html',
  styleUrls: ['./edit-long-prompt-modal.component.css']
})
export class EditLongPromptModalComponent {

  @Input() text: string;

  constructor(public activeModal: NgbActiveModal) { }

  cancelClicked = function () {
    this.activeModal.dismiss();
  }

  saveClicked = function () {
    this.activeModal.close(this.text);
  }

}
